export const MAX_LEG_REQUEST_CHARTER = 6;
export const DATETIME_FORMAT_STANDARD = "YYYY-MM-DD HH:mm";
export const DATETIME_FORMAT_SHORT = "MMM DD, YYYY";
export const DATE_FORMAT_DEPARTURE_SHORT = "ddd, MMM DD";
export const DATETIME_FORMAT_FULL = "DD MMM YYYY, HH:mm";
export const DATETIME_FORMAT_FULL_12H = "DD MMM YYYY, hh:mm A";
export const DATETIME_FORMAT_DEPARTURE = "MMM DD, YYYY - HH:mm";
export const DATETIME_FORMAT_DEPARTURE_12H = "MMM DD, YYYY - hh:mm A";
export const TIME_FORMAT_24 = "HH:mm";
export const TIME_FORMAT_12 = "hh:mm A";
export const REGEX_EMAIL =
	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REGEX_PASSWORD =
	/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+~\-=?<>])(?=.{8,})[A-Za-z\d!@#$%^&*()_+~\-=?<>]{8,}$/;
export const REGEX_PHONE = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
export const OTP_TIMEOUT = 5; // minutes
export const US_SHORT_CODE = "US";

export const JET_ONE_SUITES_OPTIONS = {
	DEPARTURE: "DEPARTURE",
	RETURN: "RETURN",
	BOTH: "BOTH",
};

export const JET_ONE_SUITES_STATUS = {
	CREATED: "CREATED",
	CONFIRMED: "CONFIRMED",
	REJECTED: "REJECTED",
	CANCELLED: "CANCELLED",
};

export const NOTIFICATION_TYPE = {
	SUCCESS: "success",
	ERROR: "error",
	INFO: "info",
	WARNING: "warning",
};

export const FLIGHT_REQUEST_OPTIONS = {
	ONE_WAY: "ONE_WAY",
	ROUND_TRIP: "ROUND_TRIP",
	MULTI_LEG: "MULTI_LEG",
};

export const JET_ONE_SUITE_REQUEST_STATUS = {
	UNACTIVATED: "UNACTIVATED",
	REQUESTING: "REQUESTING",
	ACTIVATE: "ACTIVATE",
	REJECTED: "REJECTED",
	DEACTIVATED: "DEACTIVATED",
	BLOCKED: "BLOCKED",
	DELETED: "DELETED",
};

export const SUITE_REQUEST_LEVEL = {
	VIEw: 2,
	EDIT: 3,
};

export const ROYAL_AIR_J1S_TIMEZONE = "America/New_York";
export const UPLOAD_ICON_MAX_SIZE = 20480;
export const UPLOAD_IMAGE_MAX_SIZE = 10485760;
export const UPLOAD_ONE_KB = 1024;
export const UPLOAD_ONE_MB = 1048576;

export const FILE_TYPE = {
	MAIN: "MAIN",
	BACKGROUND: "BACKGROUND",
	GALLERY: "GALLERY",
};

export const CONTACT_TYPE = {
	GENERAL_INQUIRY: "GENERAL_INQUIRY",
	AIR_FREIGHT: "AIR_FREIGHT",
	JET_ONE_SUITE: "JET_1_SUITES",
	AIRCRAFT_CHARTER: "AIRCRAFT_CHARTER",
	JET_CARD: "JET_CARD",
};

export const CONTACT_TYPE_OPTIONS = [
	{ value: "GENERAL_INQUIRY", label: "General Inquiry" },
	{ value: "AIR_FREIGHT", label: "Air Freight" },
	{ value: "JET_1_SUITES", label: "Jet 1 Suites" },
	{ value: "AIRCRAFT_CHARTER", label: "Aircraft Charter" },
	{ value: "JET_CARD", label: "Jet Card" },
	{ value: "EMPLOYMENT", label: "Employment" },
];

export const WEBSITE_CONTENT_SLUGS = {
	HOMEPAGE: "homepage",
	SERVICES: "services",
	AIRCRAFT: "aircraft",
	JOURNEY: "journey",
	CONTACT: "contact",
	PORTAL: "portal",
	FAGS: "faqs",
	WELCOME_TO_JET_1_SUITES: "portal-welcome-to-jet-1-suites",
	PORTAL_DASHBOARD: "portal-dashboard",
	PRIVATE_JET_TRAVEL: "service-private-jet-travel",
	AIR_FREIGHT: "service-air-freight",
	JET_1_SUITES: "service-jet-1-suites",
	TRUSTED_PARTNERS: "trusted-partners",
};

export const TIME_SETTING_TYPES = {
	TWELVE_HOURS_FORMAT: "TWELVE_HOURS_FORMAT",
	TWENTY_FOUR_HOURS_FORMAT: "TWENTY_FOUR_HOURS_FORMAT",
};

export const FILE_UPLOAD_TYPE = {
	ACC: "audio/aac",
	APNG: "image/apng",
	AVIF: "image/avif",
	AVI: "video/x-msvideo",
	AZW: "application/vnd.amazon.ebook",
	BMP: "image/bmp",
	CDA: "application/x-cdf",
	CSS: "text/css",
	CSV: "text/csv",
	DOC: "application/msword",
	DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	EOT: "application/vnd.ms-fontobject",
	E_PUB: "application/epub+zip",
	GIF: "image/gif",
	HTM: "text/html",
	ICO: "image/vnd.microsoft.icon",
	ICS: "text/calendar",
	JPEG: "image/jpeg",
	JS: "text/javascript",
	JSON: "application/json",
	JSONLD: "application/ld+json",
	MID: "audio/midi",
	XMID: "audio/x-midi",
	MP3: "audio/mpeg",
	MP4: "video/mp4",
	MPEG: "video/mpeg",
	MPKG: "application/vnd.apple.installer+xml",
	ODP: "application/vnd.oasis.opendocument.presentation",
	ODS: "application/vnd.oasis.opendocument.spreadsheet",
	ODT: "application/vnd.oasis.opendocument.text",
	OGA: "audio/ogg",
	OGV: "video/ogg",
	OGX: "application/ogg",
	OPUS: "audio/ogg",
	OTF: "font/otf",
	PNG: "image/png",
	PDF: "application/pdf",
	PPT: "application/vnd.ms-powerpoint",
	PPTX: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
	RTF: "application/rtf",
	SVG: "image/svg+xml",
	TIF: "image/tiff",
	TTF: "font/ttf",
	TXT: "text/plain",
	VSD: "application/vnd.visio",
	WAV: "audio/wav",
	WEBA: "audio/webm",
	WEBM: "video/webm",
	WEBP: "image/webp",
	WOFF: "font/woff",
	WOFF2: "font/woff2",
	XHTML: "application/xhtml+xml",
	XLS: "application/vnd.ms-excel",
	XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	XML: "application/xml",
	AUDIO_3GP: "audio/video",
	AUDIO_3G2: "audio/video",
};

export const AIRCRAFT_CATEGORY_CLASS_TYPE = {
	CLASS_TURBO_PROPS: "CLASS_TURBO_PROPS",
	CLASS_LIGHT_JET: "CLASS_LIGHT_JET",
	CLASS_MIDSIZE: "CLASS_MIDSIZE",
	CLASS_SUPER_MIDSIZE: "CLASS_SUPER_MIDSIZE",
	CLASS_HEAVY: "CLASS_HEAVY",
	CLASS_LONG_RANGE: "CLASS_LONG_RANGE",
};

export const AIRCRAFT_LOCATIONS = {
	DETROIT: "detroit",
	MIAMI: "miami",
	LOS_ANGELES: "los_angeles",
};

export const AIRCRAFT_PROVIDER = {
	ROYAL_AIR: "ROYAL_AIR",
	PARTNER: "PARTNER",
};
